import packageJson from '../../package.json';

export const VERSION = process.env.APP_VERSION || packageJson.version;
